/**
 * @fileoverview Widget Limit Sabitleri
 *
 * Kullanici etkilesimi sinirlari ve zaman asimi degerleri.
 *
 * @module utils/constants/limits
 */

/**
 * Arama gecmisinde saklanacak maksimum arama sayisi.
 *
 * @constant {number}
 */
export const MAX_SEARCH_HISTORY = 10;

/**
 * Kullanicinin kaydedebilecegi maksimum arama sayisi.
 *
 * @constant {number}
 */
export const MAX_SAVED_SEARCHES = 20;

/**
 * Ayni anda karsilastirilabilecek maksimum ilan sayisi.
 *
 * @constant {number}
 */
export const MAX_COMPARE_LISTINGS = 3;

/**
 * Arama ve API limitleri.
 *
 * @constant {Object}
 */
export const LIMITS = {
  DEFAULT_SEARCH: 20,
  MAP_SEARCH: 30,
  PROJECTS: 5,
  SEARCH_HISTORY: 10,
  MAX_COMPARE: 3,
  MAX_SAVED: 5,
  SEARCH_RESULTS_INITIAL: 10,
  SEARCH_RESULTS_LOAD_MORE: 20,
  MAX_SEARCH_HISTORY: 10,
};

/**
 * Zaman asimi ve gecikme degerleri (milisaniye).
 *
 * @constant {Object}
 */
export const TIMEOUTS = {
  SCROLL_DEBOUNCE: 50,
  FIT_MAP_DELAY: 100,
  SCROLL_ANIMATION: 500,
  MAP_RESIZE: 200,
};

/**
 * Ilan durumu sabitleri.
 *
 * @constant {Object}
 */
export const LISTING_STATUS = {
  NEW_LISTING_DAYS: 3,
  OLD_BUILDING_AGE: 25,
};
